<template>
  <div class="my-3 mx-3">
    <div
      class="card smcard"
      :class="{
        'pcard-dark': nightMode,
        pcard: !nightMode,
        'bg-dark3': nightMode,
      }"
    >
      <img
        class="card-img-top"
        :src="portfolio.pictures[0].img"
        alt="Card image cap"
      />
      <div class="middle">
        <div class="text-middle">
          {{ portfolio.descriptions }}
          <br />
          <p style="font-size:12px;font-weight: normal">
            {{ portfolio.sub_des }}
          </p>

          <a
            v-if="portfolio.video_link"
            class="btn btn-outline-secondary mx-0"
            :href="portfolio.video_link"
            target="_blank"
          >
            <i class="fa fa-play-circle fa-lg" style="color:white"></i>
          </a>
          <a
            v-if="portfolio.google_play"
            class="btn btn-outline-secondary mx-0 ml-1"
            :href="portfolio.google_play"
            target="_blank"
          >
            <i class="fab fa-google-play fa-lg" style="color:white"></i>
          </a>
          <a
            v-if="portfolio.news"
            class="btn btn-outline-secondary mx-0 ml-1"
            :href="portfolio.news"
            target="_blank"
          >
            <i class="fas fa-newspaper fa-lg" style="color:white"></i>
          </a>
          <a
            v-if="portfolio.apps"
            class="btn btn-outline-secondary mx-0 ml-1"
            :href="portfolio.apps"
            target="_blank"
          >
            <i class="fab fa-app-store fa-lg" style="color:white"></i>
          </a>

          <button
            href=""
            class="btn-sm btn btn-outline-secondary no-outline ml-1"
            @click.prevent="showModal"
          >
            read more
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CardSkill",
  props: {
    portfolio: {
      type: Object,
      required:true,
    },
    nightMode: {
      type: Boolean,
    },
  },
  methods: {
    open(url) {
      window.open(url, "_blank");
    },
    showModal() {
      this.$emit("show", this.portfolio);
    },
  },
  created() {
    // console.log(this.portfolio.name);
  },
};
</script>
<style scoped>
/* .card-img-top:hover {
  opacity: 0.1;
} */
.middle:hover {
  opacity: 0.84;
}
.title2 {
  font-size: 20px;
  font-weight: 400;
}
a {
  font-size: 12px;
  color: #669db3ff !important;
}
.text-middle {
  /* background-color: #04AA6D; */
  color: white;
  font-size: 15px;
  /* margin-bottom: 8px; */
  font-weight: bold;
  position: absolute;
  bottom: 40px;
  left: 50px;
  text-align: left;
}
.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 460px;
  height: 300px;
  /* border-radius: 10px; */
  transform: translate(-49%, -49%);
  /* -ms-transform: translate(-50%, -50%); */
  text-align: center;
  background-color: #272727;
  z-index: 1;
}
img {
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  /* background-color: #90acd1; */
}
.card-img-top {
  background-color: transparent;
  opacity: 1;
}
.img-div img {
  /* object-fit: cover;
    overflow: hidden; */
  margin-left: auto;
  margin-right: auto;
  display: block;
  /* object-position: 50% 120%;
    max-width: 300px !important; */
}
.bheight {
  height: 65px;
  overflow: auto;
}
.pheight {
  height: 110px;
  max-height: 130px;
  overflow: auto;
  text-align: justify;
}
div.img-div {
  position: absolute;
  width: 100%;
  height: 100%;
}
.pborder-top {
  border-top: 1px solid rgb(193, 193, 193);
}
.pcard {
  /* background-color: rgb(255, 255, 255); */
  /* background-color: #90acd1; */
  border-radius: 0px;
  border: none;
  /* box-shadow: 1px 1px 12px rgb(233, 233, 233); */
  transition: all 0.5s;
  /* height: 500px; */
  height: 400px;

  width: 500px;
  background-color: transparent;
  margin-left: auto;
  margin-right: auto;
}
.pcard:hover {
  transition: all 0.5s;
  /* cursor: pointer; */
  /* box-shadow: 1px 1px 15px rgb(216, 216, 216); */
}
.pcard-dark {
  border-radius: 0px;
  border: none;
  background-color: #262c30 !important;

  /* background-color: #30363a !important; */
  /* box-shadow: 1px 1px 12px rgb(53, 53, 53); */
  transition: all 0.5s;
  height: 400px;

  width: 500px;
}
.pcard-dark:hover {
  transition: all 0.5s;
  /* cursor: pointer; */
  box-shadow: 1px 1px 12px rgb(53, 53, 53);
}
.pcard-body {
  border-top: 1px solid rgb(220, 220, 220);
  z-index: -1;
  background-color: rgb(253, 254, 255);
}
.title {
  font-size: 30px;
  font-weight: 500;
}
.title1 {
  font-size: 24px;
  font-weight: 400;
}
.title2 {
  font-size: 20px;
  font-weight: 400;
}
.title3 {
  font-size: 16px;
  font-weight: 400;
}
.badge {
  background-color: rgb(211, 227, 233);
  transition: all 0.5s;
  font-weight: 500;
  font-size: 13px;
}
.btn {
  border-color: #669db3ff;
  color: #669db3ff;
}
.btn:hover {
  background-color: #669db3ff;
  border-color: #669db3ff;
  color: white;
}
.btn:focus {
  background-color: #669db3ff;
  border-color: #669db3ff;
  color: white;
}
.bg-dark3 {
  background-color: rgb(82, 82, 82);
}
.bg-dark4 {
  background-color: #494e55 !important;
}

@media screen and (max-width: 480px) {
  .pcard{
    width: 100%;
    height: 0%;
    /* margin-bottom: -57%; */
  }
  .middle{
    width: 92%;
    height: 84%;
    /* top: 32%; */
    
  }

  .text-middle{
    width: 90%;
    left: 20px;
  }
}
</style>
